import { render } from "./quiz-v1-self-assessment.vue?vue&type=template&id=594869ba"
import script from "./quiz-v1-self-assessment.vue?vue&type=script&lang=js"
export * from "./quiz-v1-self-assessment.vue?vue&type=script&lang=js"

import "./quiz-v1-self-assessment.vue?vue&type=style&index=0&id=594869ba&lang=sass"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__